<template>
  <md-card>
    <md-card-content>
      <div class="md-subheading header">
        Config
      </div>

      <md-field class="short-field">
        <label>Cabinet URL</label>
        <md-input v-model="config['cabinet_url']" />
      </md-field>

      <md-field class="short-field">
        <label>Website URL</label>
        <md-input v-model="config['website_url']" />
      </md-field>

      <div>Allow VPN connection on purpose</div>
      <md-switch v-model="config['allow_vpn_connection_on_purpose']" />

      <md-card>
        <md-card-content>
          <div class="subform-subtitle">
            S3 Config
          </div>

          <md-field class="short-field">
            <label>Bucket</label>
            <md-input v-model="config.app_installer_s3_config['bucket']" />
          </md-field>

          <md-field class="short-field">
            <label>Filename path</label>
            <md-input v-model="config.app_installer_s3_config['filename_path']" />
          </md-field>

          <md-field class="short-field">
            <label>S3 Region</label>
            <md-input v-model="config.app_installer_s3_config['s3_region']" />
          </md-field>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-content>
          <div class="subform-subtitle">
            Email Config
          </div>

          <md-field class="short-field">
            <label>Email Client API Key</label>
            <md-input v-model="config.email_config.email_client_api_key" />
          </md-field>

          <md-field class="short-field">
            <label>Password reset URL</label>
            <md-input v-model="config.email_config.reset_password_url" />
          </md-field>

          <md-field class="short-field">
            <label>Verification Email URL</label>
            <md-input v-model="config.email_config.verification_email_url" />
          </md-field>

          <md-field class="short-field">
            <label>Finish Registration Email URL</label>
            <md-input v-model="config.email_config.finish_registration_url" />
          </md-field>

          <md-field class="short-field">
            <label>Subscribe for newsletters URL</label>
            <md-input v-model="config.email_config.subscribe_for_newsletters_url" />
          </md-field>
        </md-card-content>
      </md-card>

      <md-card-actions>
        <md-button
          type="submit"
          class="md-primary"
          :disabled="isLoading"
          @click.native="saveAppConfig"
        >
          <span v-if="!isLoading">Save</span>
          <md-progress-spinner
            v-else
            :md-diameter="15"
            :md-stroke="3"
            md-mode="indeterminate"
          />
        </md-button>
      </md-card-actions>
    </md-card-content>
  </md-card>
</template>

<script>
    export default {
        props: { appIdentity: { type: String, required: true }},
        data() {
            return {
                config: {
                    app_identity: this.appIdentity,
                    cabinet_url: "",
                    website_url: "",
                    allow_vpn_connection_on_purpose: false,

                    app_installer_s3_config: {
                        bucket: "",
                        filename_path: "",
                        s3_region: ""
                    },

                    email_config: {
                        email_client_api_key: "",
                        verification_email_url: "",
                        reset_password_url: "",
                        finish_registration_url: "",
                        subscribe_for_newsletters_url: ""
                    }
                },
                exists: false,
                isLoading: false
            };
        },
        watch: {
            appIdentity() {
                if (this.appIdentity) {
                    this.fetchAppConfig();
                }
            }
        },
        mounted() {
          this.fetchAppConfig();
        },
        methods: {
            fetchAppConfig() {
                this.$http.get(`/v1/admin/marketing/app-config/${this.appIdentity}`)
                    .then(res => {
                        this.config = res.data.app_config;
                        this.exists = true;
                    })
                    .catch(() => {
                        this.exists = false;
                    });
            },
            saveAppConfig() {
                this.isLoading = true;
                const method = this.exists ? "put" : "post";

                this.$http[method]("/v1/admin/marketing/app-config", { app_config: this.config })
                    .then(() => {
                        this.isLoading = false;
                    });
            }
        }
    };
</script>

<style scoped lang="scss">
    .short-field {
      width: 600px;
    }

    .subform-subtitle {
      padding: 5px 0 10px;
    }

    .invalid-field {
      color: #ff1745;
      input, label {
        color: #ff1745 !important;
      }
    }
</style>
